import useAnalytics from 'core/hooks/useAnalytics';
import { useEffect, useRef } from 'react';

import { EVENT_NAMES } from '../../constants/eventNames';
import { useAnalyticsFilters } from '../../contexts/AnalyticsFiltersContext';

// The visit carries no count of unattended alerts on purpose (TANAI-2603). The Radar's first page is
// the 25 newest alerts of any status, so a count taken from it is capped and can be zero while older
// ones are pending, and the API gives the exact total only to a request of its own.
function useRadarOpenedEvent(): void {
  const { trackEvent } = useAnalytics();
  const { isMockMode, loading } = useAnalyticsFilters();
  const hasTrackedOpenedRef = useRef<boolean>(false);

  useEffect(() => {
    if (loading || hasTrackedOpenedRef.current) return;
    hasTrackedOpenedRef.current = true;
    trackEvent(EVENT_NAMES.IA_TEACHER_RADAR_OPENED, { mock_mode: isMockMode })
      .then((result: unknown) => {
        // A null result means analytics was not hydrated yet, so the latch reopens for the retry.
        if (result === null) hasTrackedOpenedRef.current = false;
      })
      .catch((error: unknown) => console.error('Analytics tracking failed:', error));
  }, [isMockMode, loading, trackEvent]);
}

export default useRadarOpenedEvent;
